import React, { useEffect, useState } from "react";
import { getSchedules } from "../utilities/genesysCloudUtils";
import { RRule } from "rrule";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Schedules({
  checkedDivisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  opts,
  setOpts,
  filters,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    generateSchedules();
  }, [pageNumber, checkedDivisions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
  }, [checkedDivisions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setTabName("schedules-tab");
    setOpts({ name: "" })
    setIsVisible({ divisions: true, object: true, applyButton: true })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
    generateSchedules();
    console.log("Generating Schedules with filters:", filters);
  }, [filters.name]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateSchedules = (resetPage = false) => {
    const currentPage = resetPage ? 1 : pageNumber;

    if (resetPage && pageNumber !== 1) {
      setPageNumber(1);
    }

    let opts = {
      pageSize: 100, // Number | Page size
      pageNumber: currentPage,
      sortBy: "name", // String | Sort by
      sortOrder: "ASC", // String | Ascending or descending sort order
      name: "",
      divisionId: checkedDivisions, // [String] | List of divisionIds on which to filter.
    };

    if (filters.name && filters.name.length > 0) {
      opts.name = `*${filters.name}*`;
    }
    getSchedules(opts).then((data) => {
      setSchedules(data.entities);
      setPageCount(data.pageCount);
    });
  };

  const allVisibleSelected = schedules.length > 0 && schedules.every((schedule) => selectedExportRows[schedule.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      filteredExportAvailable={true}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: schedules })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(schedules, checked)}
      rowCount={schedules.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Schedules"
    >
      {schedules ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                <th className="count-column">Count</th>
                <th>Schedule Name</th>
                <th>Schedule Start</th>
                <th>Schedule End</th>
                <th>Evaluated Rule</th>
                <th>Schedule Rrule</th>
                <th>Division</th>
                <th>Schedule Id</th>
              </tr>
            </thead>
            <tbody>
              {schedules.map((schedule, index) => {
                return (
                  <tr key={schedule.id}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${schedule.name} for export`}
                        checked={Boolean(selectedExportRows[schedule.id])}
                        onChange={(event) => onToggleExportRow(schedule, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index count-column">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 100 + index + 1}
                    </th>
                    <td>{schedule.name}</td>
                    <td className="centered-text">{schedule.start.slice(11, 16)}</td>
                    <td className="centered-text">{schedule.end.slice(11, 16)}</td>
                    {schedule.rrule ? (
                      <td className="schedule-rule">
                        {RRule.fromString(schedule.rrule).toText()}
                      </td>
                    ) : (
                      // <td>{convertRrule(schedule.rrule)}</td>
                      <td>{schedule.start.split("T")[0]} to {schedule.end.split("T")[0]}</td>
                    )}
                    {schedule.rrule ? (
                      <td className="schedule-rule">{schedule.rrule}</td>
                    ) : (
                      <td></td>
                    )}
                    <td>{schedule.division.name}</td>
                    <td className="centered-text"><kbd className="kbd">{schedule.id}</kbd></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
